import type { ComponentTheme } from '../types/component-theme';

import { GlassSurfaceBackgrounds } from './constants/glass-surface';

export default {
    slots: {
        root:
            'relative overflow-hidden shadow-[0_0.25rem_1rem_rgba(0,0,0,0.1)] before:pointer-events-none ' +
            'before:absolute before:inset-0 before:rounded-[inherit] before:p-[0.063rem] ' +
            'before:bg-[linear-gradient(180deg,var(--white-alpha-45),var(--white-alpha-12))] ' +
            'before:mask-[var(--mask-white-fill-bg)_content-box,var(--mask-white-fill-bg)] before:mask-exclude'
    },
    variants: {
        background: {
            [GlassSurfaceBackgrounds.Primary]: {
                root: 'bg-[linear-gradient(145deg,var(--white-alpha-55),var(--white-alpha-25))]'
            },
            [GlassSurfaceBackgrounds.Secondary]: {
                root: 'bg-[linear-gradient(180deg,var(--white-alpha-55),var(--white-alpha-25))]'
            }
        }
    }
} satisfies ComponentTheme;
